import { createCommerceAxiosClient } from '@lib/http/commerceAxiosClient';
import type { AxiosInstance } from 'axios';

let client: AxiosInstance | undefined;

/**
 * commerce-core waits on every cart call before re-enabling the mini-cart's
 * controls, so a request the gateway never answers has to fail instead: its
 * read shows commerce-ui's retry view and a failed mutation settles.
 */
export const MINI_CART_REQUEST_TIMEOUT_MS = 20_000;

/**
 * A read gives up sooner: commerce-core retries a failed cart read three
 * times, so at the request timeout a hung read showed its error after ~88s.
 * Healthy reads answer in well under a second.
 */
export const MINI_CART_READ_TIMEOUT_MS = 6_000;

/**
 * The mini-cart's browser-direct bridge client. One per page: commerce-core
 * seeds it into the provider once.
 * Exported so stories can answer its requests.
 */
export const getMiniCartClient = (): AxiosInstance =>
  (client ??= createCommerceAxiosClient('usg-direct', {
    timeout: MINI_CART_REQUEST_TIMEOUT_MS,
    readTimeout: MINI_CART_READ_TIMEOUT_MS,
  }));

/**
 * View cart's full navigation to checkout, and the reload a tab left on an
 * old org offers, behind an object so stories can intercept them: the
 * browser's `location` cannot be stubbed.
 */
export const miniCartNavigation = {
  assign: (url: string) => window.location.assign(url),
  reload: () => window.location.reload(),
};
